import {PATH} from '@utils/Const'
import {RouteObject} from 'react-router-dom'
import React from 'react'
import RegisterPage from '@pages/NonAuthentication/RegisterPage/RegisterPage'
import LoginPage from '@pages/NonAuthentication/Login/LoginPage'
import ForgetPassword from '@pages/NonAuthentication/ForgetPassword'

const nonAuthRoute: RouteObject[] = [
  {
    path: PATH.LOGIN,
    index: true,
    element: <LoginPage />,
  },
  {
    path: PATH.REGISTER,
    element: <RegisterPage />,
  },
  {
    path: PATH.FORGET_PASSWORD,
    element: <ForgetPassword />,
  },
]

export default nonAuthRoute
